import {
  Autocomplete,
  debounce,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material'
import React, { SyntheticEvent, useState } from 'react'
import { del, get } from '../utils/api'
import { StudentInterface } from '../types/interface/student.interface'
import { ReactComponent as DeleteIcon } from '../images/svg/delete.svg'

interface Props {
  selectedOption: StudentInterface | null
  setSelectedOption: React.Dispatch<
    React.SetStateAction<StudentInterface | null>
  >
  courseName: string | null
  setCourseName: React.Dispatch<React.SetStateAction<string | null>>
}

const menuItems = [
  'Excel Basic to advance',
  'Power BI Basic to advance',
  'Python-Basic',
  'Python-Advance',
  'SQL-Basic',
  'SQL-Advance',
  'Aws',
  'Bigdata',
  'Post gradution in Data anlaytics',
  'Post graduation in Data Science with ML and DL',
  'MIS Analyst',
]

const SearchStudents = ({
  selectedOption,
  setSelectedOption,
  courseName,
  setCourseName,
}: Props) => {
  const [options, setOptions] = useState(Array<StudentInterface>)

  const getData = async (value: string) => {
    try {
      const options = await get('/api/students/' + value)
      const updatedOptions = options.map((o: { mobileNumber: string }) => ({
        ...o,
        title: o.mobileNumber,
      }))

      setOptions(updatedOptions)
    } catch (err) {
      console.error(err)
    }
  }

  const onInputChange = debounce(
    async (_event: SyntheticEvent, value: string) => {
      if (value) {
        getData(value)
      }
    },
    300
  )

  const handleChange = (
    _event: SyntheticEvent,
    value: StudentInterface | null
  ) => {
    if (value) setSelectedOption(value)
    else setSelectedOption(null)
  }

  const handleSelectCourse = (event: SelectChangeEvent<string | null>) => {
    const { value } = event.target
    if (value) setCourseName(value)
    else setCourseName(null)
  }

  const handleDeleteCertificate = async (id: string) => {
    if (id) {
      try {
        const deleteResponse = await del(`/api/certificates/${id}`)

        if (deleteResponse.deleted) {
          const updatedOption: StudentInterface = JSON.parse(
            JSON.stringify(selectedOption)
          )

          updatedOption.certificates = updatedOption.certificates?.filter(
            (cert) => cert.id !== id
          )

          setSelectedOption(updatedOption)
        }
      } catch (error) {
        console.error('ERROR WHILE DELTE CERTIFICATE', error)
      }
    }
  }

  return (
    <div className="flex flex-col gap-10 sm:w-[300px] w-full">
      <Autocomplete
        id="get-students-phone"
        options={options}
        onInputChange={onInputChange}
        getOptionLabel={(option: { title: any }) => option.title}
        style={{ maxWidth: 400 }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label="Phone Number"
            variant="outlined"
            fullWidth
            className="!text-primary"
          />
        )}
        onChange={handleChange}
      />
      {selectedOption && (
        <div className="flex flex-col gap-2 text-primary pl-2 w-full">
          <span>Phone: {selectedOption.mobileNumber}</span>
          <span>Email: {selectedOption.email}</span>
          <span>Batch: {selectedOption.batch}</span>
          <span>Name: {selectedOption.name}</span>

          <div className="flex flex-col gap-2">
            <span className="text-xl font-semibold">Certificates</span>
            <div className="flex flex-col gap-2 ml-5">
              {selectedOption.certificates?.map((cert) => (
                <span
                  key={cert.id}
                  className="flex justify-between w-full gap-2"
                >
                  <a
                    href={`/certificate/${cert.id}`}
                    target="_blank"
                    rel="noreferrer"
                    className="flex w-full"
                  >
                    {cert.courseName ?? 'No Name Provided'}
                  </a>
                  <DeleteIcon
                    className="fill-primary h-full cursor-pointer"
                    onClick={() => handleDeleteCertificate(cert.id)}
                  />
                </span>
              ))}
            </div>
          </div>

          <FormControl fullWidth className="!mt-5">
            <InputLabel id="select-course-name-label">Course</InputLabel>
            <Select
              labelId="select-course-name-label"
              id="select-course-name"
              value={courseName}
              label="Course"
              onChange={handleSelectCourse}
            >
              {menuItems.map((mi) => (
                <MenuItem key={mi} value={mi}>
                  {mi}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
    </div>
  )
}

export default SearchStudents
